export const getIsInWizardFunnel = state => state.signup.get('isInWizardFunnel')
